// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Projects_componentWrapper__HS5d-","contentContainer":"Projects_contentContainer__ZelaU","projectsContainer":"Projects_projectsContainer__2Xvjt"};